/**
 * Marketplace hand-off (imavenai.com → this adviser's widget).
 *
 * The visitor described their need on the marketplace, picked this adviser and accepted
 * the terms. widget-server /chat/handoff created the conversation (already identified) and
 * the funnel session, and issued a signed token that arrives here as ?handoff=<token>.
 *
 * This module resolves the token and primes localStorage exactly as a normal start would,
 * so the rest of chat-page keeps working unchanged (it reads conversation id, asst id,
 * directive id, visitor id and funnel session from localStorage).
 */

const IDENTIFICATION_DIRECTIVE_ID = '67be323b44fccc7abd5b7a08';
const DEFAULT_ASST_ID = 'asst_5WqDk3WVgQCoOlJO18quwhlh';

/**
 * Resolve a hand-off token. Returns the server payload, or null when the link is invalid or
 * expired (caller falls back to a normal fresh start).
 */
export async function resolveMarketplaceHandoff({ baseUrl, apikey, token, colorScheme }) {
    try {
        const res = await fetch(`${baseUrl}/chat/handoff/${encodeURIComponent(token)}`, {
            method: 'GET',
            headers: { 'x-apikey': apikey, 'X-Color-Scheme': colorScheme || 'blue' }
        });
        if (!res.ok) {
            console.warn('[Handoff] link invalid or expired — falling back to a fresh start');
            return null;
        }
        const data = await res.json();
        return data && data.conversationId ? data : null;
    } catch (e) {
        console.warn('[Handoff] failed to resolve token:', e);
        return null;
    }
}

/** Prime localStorage the way /chat/start + createFunnelSession would have. */
export function primeStorageFromHandoff(h) {
    localStorage.setItem('imavenconvoid', h.conversationId);
    localStorage.setItem('asstId', DEFAULT_ASST_ID);
    localStorage.setItem('directiveId', IDENTIFICATION_DIRECTIVE_ID);
    if (h.visitorId) localStorage.setItem('imaven_visitor_id', h.visitorId);
    if (h.sessionId) {
        localStorage.setItem('imaven_funnel_session', JSON.stringify({
            sessionId: h.sessionId,
            expertId: h.expertData && h.expertData.expertId,
            createdAt: new Date().toISOString()
        }));
    }
}
